// extracted by mini-css-extract-plugin
export var avatarContainer = "_ci-0";
export var avatarTypingWave = "_ci-i";
export var gray = "_ci-f";
export var green = "_ci-c";
export var icon = "_ci-9";
export var image = "_ci-1";
export var lg = "_ci-6";
export var md = "_ci-5";
export var presenceDot = "_ci-b";
export var red = "_ci-d";
export var sm = "_ci-4";
export var status = "_ci-a";
export var typingDot = "_ci-h";
export var typingPill = "_ci-g";
export var xl = "_ci-7";
export var xs = "_ci-3";
export var xxl = "_ci-8";
export var xxs = "_ci-2";
export var yellow = "_ci-e";